<!-- <span style="position:absolute;top:0;left:200px;font-size:small;color:black;">myfxorder version : {{appVersion()}}</span> -->
<router-outlet />